import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

export const productRegistration = (payload) =>
  connectApi({ method: "POST", url: baseURL.productRegistration, payload });
